



























































































































import {
  defineComponent,
  ref,
  getCurrentInstance,
  ComponentInternalInstance,
  computed,
  watch,
  onMounted,
  onUnmounted,
  toRefs,
} from '@vue/composition-api';
import { UserIcon } from 'tdesign-icons-vue';
import _ from 'lodash';

// 引入组件
import Advert from '@/renderer/components/common/Advert.vue';
import headbar from '@/renderer/views/desktop/headbar/index.vue';
import SharedList from '@/renderer/views/share/components/SharedList.vue';
import OffenceDialog from '@/renderer/views/share/components/offenceDialog.vue';

// 引入 compositions
import shareLinkHandler from '@/renderer/views/share/compositions/shareLinkHandler';

// 引入工具类
import tips from '@/renderer/scripts/utils/tips';
import ipc from '@/renderer/scripts/utils/ipc';
import user, { User } from '@/renderer/scripts/utils/user';
import i18n, { i18n_t } from '@/locales/i18n';
export default defineComponent({
  components: {
    UserIcon,
    headbar,
    SharedList,
    OffenceDialog,
    Advert,
  },
  filters: {
    formateCode(code: number): string {
      const map: {
        [key: number]: string;
      } = {
        // 1: '文件正在加载，请稍后查看', TODO暂时不处理这个状态
        3: i18n_t('该文件存在风险，暂不支持查看'),
      };
      return map[code];
    },
  },
  setup(props, context) {
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy || context.root;
    const store = vm.$store;
    const offenceDialogShow = ref(false);
    const extractCodeValue = ref('');
    const isLogined = computed(() => store.getters.isLogined);
    const isVistorLogined = computed(() => store.getters.isVistorLogined);
    const {
      spaceId,
      extractLoading,
      extractCode,
      status,
      methods: shareMethods,
      safeStatus,
      shareFileSpaceOrgId,
    } = shareLinkHandler();
    shareMethods.initShareId();
    shareMethods.initData();
    const shareLinkDetail = computed(() => store.getters.shareLinkDetail);
    const orgLogoInfo = computed(() => {
      const { orgLogo, orgName, showOrgNameInUI } = store.getters.shareLinkDetail;
      return {
        orgLogo,
        orgName,
        showOrgNameInUI,
      };
    });
    const showExtract = computed(() => store.getters.needExtractionCode && !status.isExtracted);
    // eslint-disable-next-line max-len
    const inWemeetMobile = computed(
      () => store.getters.isMobileStyle && !showExtract.value && store.getters.isInWeMeetApp,
    );
    const isEmpty = ref(true);
    // 是否是empty
    watch(extractCodeValue, (val: string) => {
      isEmpty.value = val.length === 0;
    });
    const mobileStyle = computed(() => store.getters.isMobile || store.getters.isMobileStyle);
    // 会议渠道分享不展示广告
    const isShowAdvert = computed(
      () =>
        (!isLogined.value || store.getters.editionFlag === 'personal') &&
        showExtract.value &&
        !store.getters.isInWeMeetApp,
    );
    isShowAdvert.value &&
      reporter.report('pay', {
        pay_source_show: 'sharelink_banner',
      });
    watch(isShowAdvert, val => {
      if (val) {
        reporter.report('pay', {
          pay_source_show: 'sharelink_banner',
        });
      }
    });
    // 放开为status为1的限制
    const warnning = computed(() => !(safeStatus.value === 2 || safeStatus.value === 1));
    const methods = {
      onExtractCodeInputBlur(val: string) {
        if (!val) return;
        extractCode.value = val.trim();
      },
      onExtractCodeInputEnter(val: string) {
        methods.onExtractCodeInputBlur(val);
        shareMethods.onExtractFiles(false);
      },
      showLoginDialog() {
        tips.info(i18n_t('请先登录后继续操作'));
        // @ts-ignore
        vm.$refs.headbar.$children[0].showLogin = true;
      },
      offenceShow() {
        offenceDialogShow.value = true;
      },
      hideLoginFun() {
        // @ts-ignore
        vm.$refs.headbar.$children[0].showLogin = false;
      },
    };
    watch(isLogined, val => {
      // 在登录状态改变的情况下需要重新调用 verifyExtractionCode 获取userToken更新
      shareMethods.onExtractFiles(false);
    });
    watch(isVistorLogined, val => {
      // 在登录状态改变的情况下需要重新调用 verifyExtractionCode 获取userToken更新
      shareMethods.onExtractFiles(false);
    });
    ipc.on(ipc.RENDERER_EVENTS_MAP.OFFENCE_SHOW, methods.offenceShow);
    ipc.on(ipc.RENDERER_EVENTS_MAP.LOGIN_DIALOG_HIDE, methods.hideLoginFun);
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.OFFENCE_SHOW, methods.offenceShow);
      ipc.off(ipc.RENDERER_EVENTS_MAP.LOGIN_DIALOG_HIDE, methods.hideLoginFun);
    });
    return {
      shareLinkDetail,
      orgLogoInfo,
      mobileStyle,
      isEmpty,
      extractCodeValue,
      offenceDialogShow,
      ...methods,
      showExtract,
      warnning,
      extractCode,
      extractLoading,
      inWemeetMobile,
      ...toRefs(status),
      spaceId,
      shareFileSpaceOrgId,
      onExtractFiles: shareMethods.onExtractFiles,
      isShowAdvert,
      safeStatus,
    };
  },
});
